import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext } from "react";
import { useStringMap } from "../utilities/string-map/useStringMap";
import { useCombineRefs } from "../hooks/useCombineRefs";
import { MenuListContext } from "../menu-list/MenuListContext";
import { getMenuListItemControlRole } from "./getMenuListItemControlRole";
import * as StyledBack from "./BackMenuListItem.styled";
import { stringMapDefault } from "./MenuListItem.stringMap";
export const BackMenuListItem = forwardRef((props, ref) => {
    const { mode } = useContext(MenuListContext);
    const { stringMap: stringMapProp, hasField, label, onClick, ...otherProps } = props;
    const stringMap = useStringMap("MenuListItem", { stringMapDefault, stringMapProp });
    const handleKeyDown = (event) => {
        if (event.key === "ArrowLeft" || event.key === " ") {
            event.preventDefault();
            onClick && onClick(event, props);
        } /*  else if (event.key === "Tab" && mode === "select") {
          event.preventDefault();
          onTabKeyPress && onTabKeyPress();
        } */
    };
    const handleClick = (event) => {
        event.stopPropagation();
        onClick && onClick(event, props);
    };
    const { backLabel } = stringMap;
    // Prevents double-reading on screen-readers, if identical
    const iconLabel = backLabel === label ? undefined : backLabel;
    const backAriaProps = iconLabel ? { "aria-label": iconLabel } : { "aria-hidden": "true" };
    const buttonRef = useCombineRefs(useCallback((el) => {
        // TODO: replace with explicit focus management on the container
        el?.focus();
    }, []), ref);
    const role = getMenuListItemControlRole({ mode });
    // TODO: conditionally render listitem > button or menuitem | option
    // use base layout (Styled.Item) to have common focus styles
    return (_jsxs(StyledBack.BackOptionItem, { ref: buttonRef, role: role, tabIndex: 0, hasField: hasField, "data-menu-list-item": true, "data-primary-focus-target": true, "data-testid": "BackMenuListItem", palette: "interactiveConstructive", onClick: handleClick, onKeyDown: handleKeyDown, ...otherProps, children: [_jsx(StyledBack.BackIcon, { ...backAriaProps }), " ", label] }));
});
BackMenuListItem.displayName = "BackMenuListItem";
BackMenuListItem.defaultProps = {
    label: "Back"
};
